import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard, faCalendar } from "@fortawesome/free-solid-svg-icons";


const EmployersPlans = ({ planDetails }: any) => {
    const plans = [
        { name: "Single Plan", value: planDetails?.singlePlan?.total || 0 },
        { name: "Monthly Plan", value: planDetails?.monthlyPlans?.total || 0 },
        { name: "Annual Flex 12 Plan", value: planDetails?.annualFlex_12?.total || 0 },
        { name: "Annual Flex 24 Plan", value: planDetails?.annualFlex_24?.total || 0 },
        { name: "Custom Annual Plan", value: planDetails?.customAnnual?.total || 0 },
    ];

    return (
        <div className="w-full">
            <div className="grid gap-4 grid-cols-5">
                {plans.map((plan, index) => {
                    // Choose which icon to show
                    const isCreditCard =
                        plan.name === "Single Plan" || plan.name === "Custom Annual";
                    const icon = isCreditCard ? faCreditCard : faCalendar;

                    return (
                        <div
                            key={index}
                            className="rounded-lg mt-2  bg-white border p-6 bg-card text-card-foreground shadow-sm"
                        >
                            <div className="flex justify-between items-center">
                                {/* Left content */}
                                <div className=" w-full">
                                    <div className="text-lg w-full flex justify-between text-gray-500 text-muted-foreground">
                                        <p>
                                            {plan.name}
                                        </p>
                                        <div>
                                            <FontAwesomeIcon
                                                icon={icon}
                                                className="text-gray-200 text-2xl hover:text-instant-teams-blue-Main transition-colors duration-200"
                                            />
                                        </div>


                                    </div>
                                    <p className="text-xl text-instant-teams-blue-Main font-bold">
                                        {plan.value}
                                    </p>
                                </div>

                                {/* Right icon */}

                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EmployersPlans;
